"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgNotificationBellWithoutCircle = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 25, height: 32, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M1.001 20.323v-.284a4.68 4.68 0 0 1 .782-2.365 6.332 6.332 0 0 0 1.551-3.007c0-.867 0-1.745.076-2.612C3.801 7.884 7.925 5 12 5h.1c4.074 0 8.199 2.884 8.602 7.055.076.867 0 1.745.063 2.612a6.443 6.443 0 0 0 1.552 3.02c.473.7.744 1.512.782 2.352v.272A4.637 4.637 0 0 1 22 23.418a5.858 5.858 0 0 1-3.708 1.782 58.601 58.601 0 0 1-12.5 0 5.92 5.92 0 0 1-3.707-1.782A4.685 4.685 0 0 1 1 20.323Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), (0, jsx_runtime_1.jsx)("path", { opacity: 0.4, d: "M8.872 29.507a4.014 4.014 0 0 0 5.575.656c.254-.19.483-.41.68-.656", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })] }))); };
exports.default = SvgNotificationBellWithoutCircle;
